<template>
  <add-text-collection
    :groupId="groupId"
    itemType="Collection"
    :addItems="server.addItemsToGroupEditPermissions"
    :addingEditPermissions="true"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import sl from '@/serviceLocator';
import { confirmNavigation } from '@/utils/confirmNavigation';
import AddTextCollection from '../../../components/AddTextCollection.vue';

export default defineComponent({
  name: 'AddEditCollections',
  components: { AddTextCollection },
  props: {
    groupId: {
      type: String,
      required: true,
    },
  },
  // The options-API guard is still supported by vue-router and, unlike
  // onBeforeRouteLeave, does not warn when mounted outside a router-view.
  beforeRouteLeave(_to, from) {
    return confirmNavigation(
      !from.query.saved,
      sl.get('globalActions').showUnsavedChangesWarning
    );
  },
  setup() {
    const server = sl.get('serverProxy');
    return {
      server,
    };
  },
});
</script>
